export default function Step4(props: any) {
    return (
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M54 23V14C54 12.8954 53.1046 12 52 12H12C10.8954 12 10 12.8954 10 14V50C10 51.1046 10.8954 52 12 52H52C53.1046 52 54 51.1046 54 50V41"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
            />
            <path
                d="M17 32H26.8851C26.9563 32 27.022 32.0378 27.0579 32.0992L30.3272 37.7038C30.4044 37.8361 30.5956 37.8361 30.6728 37.7038L37.3386 26.2768C37.4131 26.149 37.5957 26.1435 37.6777 26.2666L41.4406 31.9109C41.4777 31.9666 41.5402 32 41.607 32H53.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
            />
        </svg>
    );
}
